import { render } from "./FacebookLogo.vue?vue&type=template&id=c8fe8dac&scoped=true"
import script from "./FacebookLogo.vue?vue&type=script&lang=js"
export * from "./FacebookLogo.vue?vue&type=script&lang=js"

import "./FacebookLogo.vue?vue&type=style&index=0&id=c8fe8dac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8fe8dac"]])

export default __exports__